module.exports = __webpack_public_path__ + "img/event_icon01.f496d01f.svg";